// src/pages/MS/MSL101F1.jsx
import React, {useEffect, useState} from 'react';
import dayjs from 'dayjs';

import DataGrid from "components/DataGrid/DataGrid";
import DatePicker from "components/DatePicker/DatePicker";
import {postData} from "utils/TransactionUtil";
import style from "./MSL101F1.module.scss";
import Button from "../../components/Button/Button";
import Icon from "../../components/Icon/Icon";

const MSL101F1 = ({navBar: NavBar}) => {

    //사용자리스트
    const [rows_logeList, setRows_logeList] = useState([]);
    const cols_logeList = [
        { key: 'sqnc',       name: 'NO',       width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'frstRgstDt', name: '생성일자',  width: '15%', },
        { key: 'lginId',     name: '사용자ID',  width: '10%' },
        { key: 'userNm',     name: '사용자명',  width: '10%',},
        { key: 'srvrIp',     name: '접속IP',   width: '10%', },
        { key: 'action',     name: '행위',     width: '10%' },
        { key: 'systMesgCtn',name: '내용',     width: '40%', cellClass: 'align_left', tooltip:true},
    ];


    //검색 조건
    const [startDate, setStartDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());



    useEffect(() => {

        getLogList(); //그룹 공통 코드 조회

    }, []);


    // 검색값 입력후 엔터
    const handleKeyDown_schUserNm = (e) => {
        //e.preventDefault();

        if (e.key === 'Enter') {
            getLogList().then(r => {});
        }
    };

    const handleClick_search = () => {
        getLogList().then(r => {});
    }

    //로그리스트 조회
    async function getLogList(){

        const param = {
            //schUserNm : e.target.value,
            schLginId : "",
            schSysAdmin:"",
            schStartDate:dayjs(startDate).format("YYYY.MM.DD"),
            schEndDate:dayjs(endDate).format("YYYY.MM.DD"),
        }
        const res = await postData("/MSL/getLogList", param);
        setRows_logeList(res);
    }

    return(
        <main className={style.main_wrap}>
             <NavBar>
                {/*Nav 내용*/}
            </NavBar>
            {/*검색영역*/}
            <div className={style.search_wrap}>
                <span className={style.schTitle}>사용자명</span>
                <input
                    type="text"
                    className={style.schUserNm}
                    name="schUserNm"
                    maxLength="12"
                    placeholder="사용자명 또는 ID 검색"
                    onKeyDown={(e) => handleKeyDown_schUserNm(e)}
                />
                <span className={style.schTitle}>검색일자</span>
                <DatePicker selDate={startDate} onChange={(date) => setStartDate(date)}/>
                <span>~</span>
                <DatePicker selDate={endDate} onChange={(date) => setEndDate(date)}/>
                <Button variant="default" size="md" addStyle={{width: "70px", height: "38px"}}
                        onClick={() => handleClick_search()}>
                    조회<Icon id="rightAngleBrackets_02" width="16" height="16"/>
                </Button>
            </div>
            {/*내용*/}
            <div className={style.main_wrap}>
                <DataGrid
                    cols={cols_logeList}
                    rows={rows_logeList}
                    size='md'
                    headerRowHeight={45}
                    rowHeight={30}
                    sortable={true}
                    isNodataView={true}
                    isRowColorful={false}
                />
            </div>
        </main>
    )
}
export default MSL101F1;
